import { Flex, Table } from 'antd'
import { ColumnsType } from 'antd/lib/table'

import { useInvestigationsServiceGetListSpecimenInvestigationsEndpoint } from 'src/api/queries'
import { SpecimenInvestigationItemDto } from 'src/api/requests'
import { TbTag } from 'src/components'
import { useLocales } from 'src/locales'

import { LaboratoryStatusTag } from './LaboratoryStatusTag'
import { TestStatusTag } from './TestStatusTag'

type Props = {
  specimenId?: string
  institutionId: string
  showLaboratoryStatus?: boolean
}

export const SpecimenInvestigationsExpandedRow = ({
  specimenId,
  institutionId,
  showLaboratoryStatus
}: Props) => {
  const { t, currentLang } = useLocales()

  const { data, isLoading } =
    useInvestigationsServiceGetListSpecimenInvestigationsEndpoint(
      {
        institutionIds: [institutionId],
        specimenIds: specimenId ? [specimenId] : [],
        pageNumber: 1,
        pageSize: 100
      },
      [specimenId],
      { enabled: !!specimenId }
    )

  const columns: ColumnsType<SpecimenInvestigationItemDto> = [
    {
      key: 'code',
      title: t('tests.code'),
      render: (_, { code, isTb }) => (
        <Flex gap={8} align="center">
          {code ?? '-'}
          <TbTag isTb={isTb} />
        </Flex>
      )
    },
    {
      key: 'type',
      title: t('laboratory_classifiers.investigation_type'),
      render: (_, { type }) => type?.translation?.[currentLang.value] ?? '-'
    },
    {
      key: 'category',
      title: t('investigations.category'),
      render: (_, { category }) =>
        category?.translation?.[currentLang.value] ?? '-'
    },
    ...(showLaboratoryStatus
      ? [
          {
            key: 'laboratoryStatus',
            title: t('investigations.investigation_status'),
            render: (_: unknown, record: SpecimenInvestigationItemDto) => (
              <LaboratoryStatusTag
                status={record.specimenLaboratoryStatus}
                testStatus={record.specimenStatus}
              />
            )
          }
        ]
      : []),
    {
      key: 'progress',
      title: t('form.progress'),
      render: (_, { specimenStatus }) => (
        <TestStatusTag status={specimenStatus} />
      )
    }
  ]

  return (
    <Table
      rowKey="id"
      size="small"
      loading={isLoading}
      columns={columns}
      dataSource={data?.data}
      pagination={false}
      locale={{ emptyText: t('investigations.no_investigations') }}
    />
  )
}
